<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { Head, useForm } from '@inertiajs/inertia-vue3'
import { onMounted, onUnmounted, reactive } from 'vue'
import stripslashes from '@/Shared/helper.js'
import TextInput from '@/Shared/Form/TextInput'
import SelectInput from '@/Shared/Form/SelectInput'
import TextareaInput from '@/Shared/Form/TextareaInput'
import Datepicker from 'vue3-datepicker'
import Modal from '@/Shared/Modal/ModalContactConfirm'
import ModalAlert from '@/Shared/Modal/ModalContactRepairAlert'
import Icon from '@/Shared/Icons/Icon'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import { ja } from 'date-fns/locale'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  myvalue: Array,
  pref: Object,
  subjectItems: Array,
  brand: String
})

const modal = reactive({
  open: false, 
  alert: false,
  subject: '',
  brand: '',
  nosend: false,
})
let subjectItems = []
subjectItems = ['商品についての問い合わせ', 'ブランドについての問い合わせ', '店舗についての問い合わせ', '弊社商品の新規お取引に関してのお問い合わせ', '修理について', 'それ以外のお問い合わせ']
const defaultSubject = ['件名を選択'];
const subjectItems_default = [...defaultSubject, ...subjectItems]

const formData = {
  subject: subjectItems_default[0],
  contactName: '',
  contactFurigana: '',
  contactEmail1: '',
  contactEmail2: '',
  relatedBrand: props.brand,
  relatedDate: null,
  relatedDateJP: null,
  relatedShop: '',
  relatedProduct: '',
  relatedColor: '',
  relatedSize: '',
  contactMessage: '',
}
const form = useForm('form', formData)

const openModal = () => {
  let errornum = 0


  if(! checkSubject() ){
    form.errors.subject = '件名を選択してください。'
    errornum++
  }
  if (form.contactName == '') {
    form.errors.contactName = '名前は必須です'
    errornum++
  }
	if (form.relatedShop == '') {
    form.errors.relatedShop = 'ご購入店は必須です。'
    errornum++
  }
  if (form.contactMessage == '') {
    form.errors.contactMessage = 'メッセージは必須です'
    errornum++
  }

  if (errornum >= 1) {
    var el = document.getElementsByClassName('form-name')
    el[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    modal.open = true
  }


}
// const openAlert = () => {
//   // useStore().updateModal({ id: id, category: category })
//   modal.alert = true
// }
const subjectOnChange = (event) => {
  console.log(event.target.value)
  modal.subject = event.target.value
  triggerAlert()
}
const brandOnChange = (event) => {
  console.log(event.target.value)
  modal.brand = event.target.value
  triggerAlert()
}

const triggerAlert = () => {
  if( modal.brand == 'sabbatical' && modal.subject == '修理について' ){
    modal.alert = true
    modal.nosend = true
  } else {
    modal.nosend = false
  }
}



const checkSubject = function () {
  console.log(form.subject)
  console.log(subjectItems.includes(form.subject))
  // if (!subjectItems.includes(form.subject)) {
  if (form.subject == '件名を選択') {
    return false;
  } else {
    return true
  }
}


const checkEmail = () => {
  
  let errornum = 0
  if (!checkSubject()){
    form.errors.subject = '件名を選択してください。'
    errornum++
  }

  if (form.contactEmail1 == '') {
    form.errors.contactEmail1 = 'メールは必須です'
    errornum++
  }
  if (form.contactEmail1 != form.contactEmail2) {
    form.errors.contactEmail2 = 'メールが異なります'
    errornum++
  }
  if (form.contactName == '') {
    form.errors.contactName = '名前は必須です'
    errornum++
  }
	if (form.relatedShop == '') {
    form.errors.relatedShop = 'ご購入店は必須です。'
    errornum++
  }
  if (form.contactMessage == '') {
    form.errors.contactMessage = 'メッセージは必須です'
    errornum++
  }

  if(errornum >= 1){
    var el = document.getElementsByClassName('form-name')
    el[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}


const submitform = () => {
  form.post('/contact/submit')
}
const onUserAction = () => {
  form.errors.contactName = null
  form.errors.subject = null
  form.errors.contactEmail1 = null
  form.errors.contactEmail2 = null
  form.errors.contactMessage = null
  form.errors.relatedShop = null
}

const onChange = function(newval) {
  // console.log( newval )
  // console.log( newval.getFullYear() )
  // console.log( newval.getMonth() + 1 )
  // console.log( newval.getDate() )
  const newdate =  newval.getFullYear() + '年'+  (newval.getMonth() + 1) + '月' + newval.getDate() + '日'
  form.relatedDateJP = newdate
}
onMounted(() => {


  usePref(props.pref)
  if (typeof window !== 'undefined') {
    document.addEventListener('keypress', () => {
      onUserAction()
    })
  }
})

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    document.removeEventListener('keypress', onUserAction)
  }
})
</script>

<template>
  <div class="contact">
    <Head title="お問い合わせ" />

    <div class="bg-white">
      <h2 class="page-title">
        CONTACT
        <small>お問い合わせ</small>
      </h2>

      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] lg:px-0 max-w-[600px] 2xl:max-w-[650px] pb-[60px] sm:pb-[80px]">
        <p class="text-center mb-[20px] sm:mb-[30px] text-[14px] sm:text-[15px] leading-[1.8]">お問合せの前に、よくある質問をご確認ください。<br class="sm:hidden" />よくある質問でも解決できない場合は、<br class="sm:hidden" />下記のフォームからお問合せくださいませ。</p>
				<ButtonRounded 
					text="よくある質問はこちらから" 
					url="/faq" 
					icon="arrow" 
					class="drop-shadow-[0_0_50px_rgba(0,0,0,0.05)] mb-[20px] sm:mb-[30px] " 
					style="background-color: #EEE"
				/>
        <form class="mx-auto my-[60px]" @submit.prevent="submitform">
          <ul class="[&>li]:mb-[30px] [&_small]:block [&_small]:mt-[12px] [&_small]:text-[90%] [&_small]:text-[#666]">
            <li>
              <text-input v-model="form.contactName" :error="form.errors.contactName" class="form-name" label="お名前" type="text" autofocus autocapitalize="off" placeholder="山田太郎" />
            </li>
            <li>
              <text-input v-model="form.contactFurigana" :error="form.errors.contactFurigana" label="フリガナ" type="text" autocapitalize="off" placeholder="ヤマダタロウ" />
            </li>
            <li>
              <text-input v-model="form.contactEmail1" :error="form.errors.contactEmail1" class="email-1 error" label="Eメール" type="email" autocapitalize="off" placeholder="メールアドレスを入力" />
            </li>
            <li>
              <text-input v-model="form.contactEmail2" :error="form.errors.contactEmail2" class="email-2" label="Eメール（確認用）" type="email" autocapitalize="off" placeholder="確認用メールアドレスを入力" />
            </li>
            <li>
              <label class="form-label" for="subject">件名</label>
              <select-input 
                v-model="form.subject"
                name="subject" 
                :error="form.errors.subject" 
                @change="subjectOnChange($event)" 
              >
                <option v-for="s in subjectItems_default" :key="s" :value="s">{{ s }}</option>
              </select-input>
            </li>
            <li>
              <label class="form-label" for="brand">関連ブランド</label>
              <select-input v-model="form.relatedBrand" @change="brandOnChange($event)">
                <option value="なし">なし</option>
                <option v-for="b in pref.brands" :key="b.brandSlug" :value="b.brandSlug" v-html="stripslashes(b.brandName)" />
              </select-input>
            </li>
            <li>
              <text-input v-model="form.relatedProduct" :error="form.errors.relatedProduct" label="商品名" type="text" autocapitalize="off" placeholder="ジャケット" />
            </li>
            <li>
              <label class="form-label" for="date-picker">ご購入日</label>
              <Datepicker v-model="form.relatedDate" :clearable="true" :locale="ja" :upper-limit="new Date()" :lower-limit="new Date('2018-01-01')" name="date-picker" class="form-input" :typeable="false" @update:model-value="onChange" />
            </li>
            <li>
              <text-input v-model="form.relatedShop" :error="form.errors.relatedShop" label="ご購入店" type="text" autocapitalize="off" />
              <small class="leading-4">※楽天市場やAmazonなどの場合は、販売元もご記入下さい。<br>※ご購入前の場合は、「ご購入前」とご記載ください。</small>
            </li>
            <li>
              <text-input v-model="form.relatedColor" :error="form.errors.relatedColor" label="カラー" type="text" autocapitalize="off" />
              <small>※商品にカラーがある場合にご記入下さい。</small>
            </li>
            <li>
              <text-input v-model="form.relatedSize" :error="form.errors.relatedSize" label="サイズ" type="text" autocapitalize="off" />
              <small>※商品にサイズがある場合にご記入下さい。</small>
            </li>
            <li>
              <TextareaInput v-model="form.contactMessage" :error="form.errors.contactMessage" class="resize" label="内容" autocapitalize="off" :rows="6" />
            </li>
          </ul>

          <div class="mt-[40px]">
            <template v-if="form.contactEmail1 != '' && form.contactEmail1 == form.contactEmail2 && modal.nosend == false">
              <!-- <loading-button id="trigger" :loading="form.processing" class="btn-indigo ml-auto" type="submit">送信する</loading-button> -->
              <button type="button" @click.prevent="openModal()">送信する<Icon type="arrow" /></button>
            </template>
            <template v-else-if="modal.nosend == false">
              <button type="button" @click.prevent="checkEmail()">送信する<Icon type="arrow" /></button>
            </template>
            <!-- <button type="button" @click.prevent="openModal(0, 'form')">form</button> -->
          </div>
        </form>

        <div class="text-[#666] [&>p]:mb-[20px] leading-[1.6] mt-[40px] sm:mt-[60px]">
          <p>送信いただきましたメールの回答は、迅速な対応を心がけておりますが、一週間を過ぎましても、返信メールが届かない場合には、メールアドレスに間違いがある可能性がございます。恐れ入りますが、入力していただいたメールアドレスをご確認の上、再度送信をお願いいたします。</p>
          <p>また、ご利用のメールの設定により、弊社からの返信が迷惑メールフォルダに自動で振り分けられる場合がございます。返信メールが届かない場合には、迷惑メールフォルダもご確認ください。</p>
          <!-- <p>※弊社エイアンドエフは2024年12月28日(土)～2025年1月5日(日)の期間中、年末年始休業に伴い、誠に勝手ながら本社業務を休業とさせていただきます。休業期間中もご質問を受け付けておりますが、返信は休業期間終了後に順次行わせていただきます。</p> -->
          <p>お問合せを多数いただいている場合には、返信にお時間がかかる場合もございます。あらかじめご了承くださいませ。又、土・日・祝日はお休みをいただいております。お急ぎの場合は下記の直営店舗までお問合せくださいませ。</p>
        </div>
      </div>
      <teleport to="#app">
        <transition name="fade">
          <Modal v-if="modal.open" category="form" :func="submitform" :params="form" :pref="props.pref" class="modal" @close="modal.open = false" />
        </transition>
      </teleport>

      <teleport to="#app">
        <transition name="fade">
          <ModalAlert v-if="modal.alert" category="form" :params="form" :pref="props.pref" class="modal" @close="modal.alert = false" />
        </transition>
      </teleport>
    </div>
  </div>
</template>
